import { internalDateFormat } from '../constants';
export const getOptions = ({ animate, arrayOfEnableDates, displayFormat, enableTime, isStatic = false, locale, maxDate, minDate, }) => {
    let opts = {
        animate,
        allowInput: true,
        altFormat: displayFormat,
        altInput: true,
        dateFormat: internalDateFormat.flatpickr,
        enableTime,
        maxDate,
        minDate,
        time_24hr: true,
        static: isStatic,
    };
    if (!locale.startsWith('en')) {
        opts = Object.assign(Object.assign({}, opts), { locale: locale });
    }
    if (enableTime) {
        if (locale === 'en') {
            opts = Object.assign(Object.assign({}, opts), { altFormat: `${opts.altFormat} h:i K`, time_24hr: true });
        }
        else {
            opts = Object.assign(Object.assign({}, opts), { altFormat: `${opts.altFormat} H:i` });
        }
    }
    if (arrayOfEnableDates) {
        opts = Object.assign(Object.assign({}, opts), { enable: arrayOfEnableDates });
    }
    return opts;
};
//# sourceMappingURL=getOptions.js.map